export default __webpack_public_path__ + "images/15ebc884ca638449c6f7bceea7769230-plane-left.png";